export const premiumServicedSitePictures = [
  {
    display_name: `Site 2 (pull-through)`,
    location: require("./premium_serviced_site_pictures/premium_2.jpg"),
  },
  {
    display_name: `Site 3 (pull-through)`,
    location: require("./premium_serviced_site_pictures/premium_3.webp"),
  },
  {
    display_name: `Site 55 (pull-through)`,
    location: require("./premium_serviced_site_pictures/premium_55.jpg"),
  },
  {
    display_name: `Site 56 (pull-through)`,
    location: require("./premium_serviced_site_pictures/premium_56.webp"),
  },
  {
    display_name: `Site 32 (pull-through)`,
    location: require("./premium_serviced_site_pictures/premium_32.webp"),
  },
  {
    display_name: `Site 30A (pull-through)`,
    location: require("./premium_serviced_site_pictures/premium_30a.jpg"),
  },
  {
    display_name: `Site 43 (pull-through)`,
    location: require("./premium_serviced_site_pictures/premium_43.jpg"),
  },
  {
    display_name: `Site 65 (pull-through)`,
    location: require("./premium_serviced_site_pictures/premium_65.jpg"),
  },
  {
    display_name: `Site O1 (pull-through) (picture #1)`,
    location: require("./premium_serviced_site_pictures/premium_o1.webp"),
  },
  {
    display_name: `Site O1 (pull-through) (picture #2)`,
    location: require("./premium_serviced_site_pictures/premium_o1_pic2.jpg"),
  },
  {
    display_name: `Site 30A (pull-through) (picture #1)`,
    location: require("./premium_serviced_site_pictures/premium_30a.webp"),
  },
  {
    display_name: `Site 30A (pull-through) (picture #2)`,
    location: require("./premium_serviced_site_pictures/premium_30a_pic2.webp"),
  },
  {
    display_name: `Site 30 (picture #1)`,
    location: require("./premium_serviced_site_pictures/premium_30.jpg"),
  },
  {
    display_name: `Site 30 (picture #2)`,
    location: require("./premium_serviced_site_pictures/premium_30_pic2.jpg"),
  },
  {
    display_name: `Site 30 (picture #3)`,
    location: require("./premium_serviced_site_pictures/premium_30_pic3.webp"),
  },
  {
    display_name: `Site 30 (picture #4)`,
    location: require("./premium_serviced_site_pictures/premium_30_pic4.webp"),
  },
  {
    display_name: `Site 4`,
    location: require("./premium_serviced_site_pictures/premium_4.jpg"),
  },
  {
    display_name: `Site 36 (picture #1)`,
    location: require("./premium_serviced_site_pictures/premium_36.jpg"),
  },
  {
    display_name: `Site 36 (picture #2)`,
    location: require("./premium_serviced_site_pictures/premium_36_pic2.jpg"),
  },
  {
    display_name: `Site 37 (picture #1)`,
    location: require("./premium_serviced_site_pictures/premium_37.webp"),
  },
  {
    display_name: `Site 37 (picture #2)`,
    location: require("./premium_serviced_site_pictures/premium_37_pic2.jpg"),
  },
  {
    display_name: `Site 53 (picture #1)`,
    location: require("./premium_serviced_site_pictures/premium_53.jpg"),
  },
  {
    display_name: `Site 53 (picture #2)`,
    location: require("./premium_serviced_site_pictures/premium_53_pic2.webp"),
  },
  {
    display_name: `Site 66`,
    location: require("./premium_serviced_site_pictures/premium_66.webp"),
  },
  {
    display_name: `Site S2`,
    location: require("./premium_serviced_site_pictures/premium_s2.webp"),
  },
  {
    display_name: `Site 33`,
    location: require("./premium_serviced_site_pictures/premium_33.webp"),
  },
  {
    display_name: `Site 38`,
    location: require("./premium_serviced_site_pictures/premium_38.webp"),
  },
  {
    display_name: `Site 39`,
    location: require("./premium_serviced_site_pictures/premium_39.webp"),
  },
  {
    display_name: `Site 40`,
    location: require("./premium_serviced_site_pictures/premium_40.webp"),
  },
  {
    display_name: `Site 68`,
    location: require("./premium_serviced_site_pictures/premium_68.jpg"),
  },
  {
    display_name: `Site 104`,
    location: require("./premium_serviced_site_pictures/premium_104.jpg"),
  },
  {
    display_name: `Site 110`,
    location: require("./premium_serviced_site_pictures/premium_110.jpg"),
  },
  {
    display_name: `Site B`,
    location: require("./premium_serviced_site_pictures/premium_b.jpg"),
  },
  {
    display_name: `Site C`,
    location: require("./premium_serviced_site_pictures/premium_c.jpg"),
  },
  {
    display_name: `Site D`,
    location: require("./premium_serviced_site_pictures/premium_d.webp"),
  },
  {
    display_name: `Site E`,
    location: require("./premium_serviced_site_pictures/premium_e.webp"),
  },
  {
    display_name: `Site F`,
    location: require("./premium_serviced_site_pictures/premium_f.webp"),
  },
  {
    display_name: `Site S1`,
    location: require("./premium_serviced_site_pictures/premium_s1.webp"),
  },
  {
    display_name: `Site S2`,
    location: require("./premium_serviced_site_pictures/premium_s2.webp"),
  },

  {
    display_name: `Site S1 and S2`,
    location: require("./premium_serviced_site_pictures/premium_s1_s2.webp"),
  },
  {
    display_name: `Site Z`,
    location: require("./premium_serviced_site_pictures/premium_z.webp"),
  },
];
